<template>
  <div class="wrapper height100">
    <!-- <div v-if="loading" class="d-flex align-center height100">
      <vue-loading
        loader="bars"
        color="#EE6090"
        :size="{ width: '50px', height: '50px' }"></vue-loading>
    </div> -->
    <v-container fluid class="height100">
      <div class="py-8 my-4">
        <p><b>本人確認用の認証メールを送信しました。</b></p>
        <br />
        <p>以下の手順でログインしてください。</p>
        <table>
          <tbody>
            <tr>
              <td style="vertical-align: top;">１．</td><td style="vertical-align: top;">メール内の<b>「アカウントを確認」</b>をタップして、Chromeブラウザを開く。</td>
            </tr>
            <tr>
              <td style="vertical-align: top;">２．</td><td style="vertical-align: top;">表示されるメッセージで<b>「許可する」</b>をタップする。</td>
            </tr>
            <tr>
              <td style="vertical-align: top;">３．</td><td style="vertical-align: top;">CCS HOMEアプリを開き、お子様のIDとパスワード登録画面が表示される。</td>
            </tr>
            <tr>
              <td style="vertical-align: top;">４．</td><td style="vertical-align: top;">登録を進める。</td>
            </tr>
          </tbody>
        </table>
        <br />
        <p><b>【メールが届かない場合】</b></p>
        <p><b>迷惑メールフォルダ</b>などに自動で振り分けられてないかご確認ください。</p>
      </div>
      <div class="d-flex justify-center my-5">
        <v-btn @click="reSignIn" color="primary" block> ログイン </v-btn>
      </div>

      <div>
        <v-btn @click="logout" color="primary" outlined block>
          別のアカウントで再度ログイン
        </v-btn>
      </div>
      <!-- </v-form> -->
    </v-container>
  </div>
</template>
<script lang="ts">
import Vue from 'vue';
import { defineComponent } from 'vue';

import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';

import { auth0Module } from '@/store/entityModules/auth0';

// model
import { PostFamilyRequest } from '@/model/Family';

export default defineComponent({
  methods: {
    async reSignIn() {
      await auth0Module.signinProcess();
    },
    logout() {
      auth0Module.logout();
    },
  },

  mounted() {},
});
</script>
<style lang="scss" scoped>
.wrapper {
  @supports (bottom: env(safe-area-inset-bottom)) {
    padding-top: calc(env(safe-area-inset-top));
    margin-bottom: calc(env(safe-area-inset-bottom));
  }
}
</style>
